import React, { FC, useState } from "react";
import { TableCell, IconButton, CircularProgress } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { HtmlTooltip } from "../StatusTooltip";
import { PdfProps } from "./QuotePdf";
import { generateTablePDF } from "../../../../../api/pdf";
import createDownloadLink from "../../../../../util/createDownloadLink";

const ProductionPdf: FC<PdfProps> = ({ row, loading, setLoading }) => {
  const [loadPdf, setLoadPdf] = useState(false);

  const handlePDF = async (
    id: string,
    dealerTax: number,
    codOrTerms: string,
    region: string
  ) => {
    if (loading) return;

    setLoadPdf(true);
    setLoading(true);

    try {
      const res = await generateTablePDF({
        quoteId: id,
        pdfLabel: "prod",
        dealerTax,
        codOrTerms,
        region
      });
      const fileName = `AGMillworks(PC-${row.quoteNumber})Production.pdf`;

      createDownloadLink(res.data, fileName);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadPdf(false);
      setLoading(false);
    }
  };
  return (
    <TableCell padding="checkbox" align="center" style={{ width: 100 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {row.totalUnits && row.totalUnits > 0 ? (
          <HtmlTooltip title={"Download Production PDF"}>
            <IconButton
              disabled={loadPdf}
              onClick={() =>
                handlePDF(
                  row._id,
                  "dealerTax" in row.userId && row.userId?.dealerTax
                    ? row.userId.dealerTax
                    : 0,
                  "codOrTerms" in row.userId && row.userId?.codOrTerms
                    ? row.userId.codOrTerms
                    : "",
                  "region" in row.userId && row.userId?.region
                    ? row.userId.region
                    : ""
                )
              }
              aria-label="download"
              size="large"
            >
              {loadPdf ? (
                <CircularProgress color="primary" size={14} />
              ) : (
                <GetAppIcon color={"primary"} />
              )}
            </IconButton>
          </HtmlTooltip>
        ) : (
          <HtmlTooltip title={"No Units in Quote"}>
            <IconButton aria-label="download" size="large">
              <GetAppIcon />
            </IconButton>
          </HtmlTooltip>
        )}
      </div>
    </TableCell>
  );
};

export default ProductionPdf;
